module.exports = {
      id: "published-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#published",
      toString: function () {
        return this.url;
      }
    }